import {
  ASSESSMENT_LIST, 
  ASSESSMENT_LIST_SUCCESS, 
  ASSESSMENT_LIST_ERROR,
  ASSESSMENT_SEARCH_SET, 
  ASSESSMENT_SEARCH_ASSESSMENT_TYPE,
  ASSESSMENT_SEARCH_ASSESSMENT_TYPE_SUCCESS,
  ASSESSMENT_SEARCH_ASSESSMENT_TYPE_ERROR, 
  ASSESSMENT_SEARCH_ASSESSMENT_CATEGORY,
  ASSESSMENT_SEARCH_ASSESSMENT_CATEGORY_SUCCESS,
  ASSESSMENT_SEARCH_ASSESSMENT_CATEGORY_ERROR, 
  ASSESSMENT_SEARCH_CHANGE, 
  ASSESSMENT_PAGE_SET,
  ASSESSMENT_ADD_SET,
  ASSESSMENT_ADD_MODAL_SET,
  ASSESSMENT_ADD,
  ASSESSMENT_ADD_SUCCESS,
  ASSESSMENT_ADD_ERROR,
  ASSESSMENT_ADD_CHANGE,
  ASSESSMENT_DETAIL,
  ASSESSMENT_DETAIL_SUCCESS,
  ASSESSMENT_DETAIL_ERROR,
  ASSESSMENT_VIEW_MODAL_SET,
  ASSESSMENT_EDIT_CHANGE,
  ASSESSMENT_EDIT_MODAL_SET,
  ASSESSMENT_UPDATE,
  ASSESSMENT_UPDATE_SUCCESS,
  ASSESSMENT_UPDATE_ERROR,
  ASSESSMENT_VIEW_TAB_SET,
  ASSESSMENT_UPLOAD_SET,
  ASSESSMENT_UPLOAD_SET_SUCCESS,
  ASSESSMENT_UPLOAD_SET_ERROR,
  ASSESSMENT_UPLOAD_RESET
} from '../../actions';
 
const INIT_STATE = {
  loading: true,
  file: [],
  list: {
    header:{
      name: 'code',
      order:'sorted-asc'
    },
    page:{
      current: 1,
      rows: 10
    }
  },
  add: {
      data: {
        new:{ code: '', name: '', description: '', if_select: false, url_file: '', original_file_name: '', file_name: '' }
      },
      modal: false,
      loading: false,
      message: '',
      url: '',
      type: ''
  },
  error: false,
  search:{
    modal: false,
    init:true,
    data:{
      program: false
    },
    value:{
      program: false
    },
    program:{
      loading: true,
      list:[],
      message: ''
    }
  },
  detail: {
    data: [],
    tab: 'general',
    loading: true,
  },
  view: {
    loading: true,
    data: [],
    tab: 'general',
    modal: false,
    log: {
      data: [],
      loading: false,
    },
  },
  edit: {
    loading: true,
    data: {
        new: [],
        old: []
    },
    list: {
        status: {
            data: [],
            loading: false,
        }
    },
    modal: false,
    update: {
        loading: false,
        response: '',
        message: ''
    }
  },
  search:{
    modal: false,
    init:true,
    data:{
      assessment_type: false,
      assessment_category: false
    },
    value:{
      assessment_type: false,
      assessment_category: false
    },
    assessment_type:{
      loading: true,
      list:[],
      message: ''
    },
    assessment_category:{
      loading: true,
      list:[],
      message: ''
    }
  }
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case ASSESSMENT_LIST:
      return {
        ...state,
        loading: true,
        list: {
          ...state.list
        }
        
      }
    case ASSESSMENT_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        list: {
          ...state.list,
          ...action.payload
        } 
      }
    case ASSESSMENT_LIST_ERROR:
      return {
        ...state,
        loading: false,
        error: true
      }
    case ASSESSMENT_SEARCH_SET:
      return {
        ...state,
        search:{
          ...state.search,
          data: action.payload,
        }
      }
    case ASSESSMENT_SEARCH_ASSESSMENT_TYPE:
      return {
        ...state,
        search:{
          ...state.search,
          init:false,
          assessment_type:{
            ...state.search.assessment_type,
            loading: true,
            list:[],
            message: ''
          }
        }
      }
    case ASSESSMENT_SEARCH_ASSESSMENT_TYPE_SUCCESS:
      return {
        ...state,
        search:{
          ...state.search,
          assessment_type:{
            ...state.search.assessment_type,
            loading: false,
            list: action.payload,
            message: ''
          }
        }
      }
    case ASSESSMENT_SEARCH_ASSESSMENT_TYPE_ERROR:
      return {
        ...state,
        search:{
          ...state.search,
          assessment_type:{
            ...state.search.assessment_type,
            loading: false,
            list:[],
            message: 'No se encotraron datos'
          }
        }
      }
    case ASSESSMENT_SEARCH_ASSESSMENT_CATEGORY:
      return {
        ...state,
        search:{
          ...state.search,
          init:false,
          assessment_category:{
            ...state.search.assessment_category,
            loading: true,
            list:[],
            message: ''
          }
        }
      }
    case ASSESSMENT_SEARCH_ASSESSMENT_CATEGORY_SUCCESS:
      return {
        ...state,
        search:{
          ...state.search,
          assessment_category:{
            ...state.search.assessment_category,
            loading: false,
            list: action.payload,
            message: ''
          }
        }
      }
    case ASSESSMENT_SEARCH_ASSESSMENT_CATEGORY_ERROR:
      return {
        ...state,
        search:{
          ...state.search,
          assessment_category:{
            ...state.search.assessment_category,
            loading: false,
            list:[],
            message: 'No se encotraron datos'
          }
        }
      }
    case ASSESSMENT_SEARCH_CHANGE:
      return {
        ...state,
        search:{
          ...state.search,
          value: action.payload,
        }
      }
    case ASSESSMENT_PAGE_SET:
      return {
        ...state,
        list: {
          ...state.list,
          page: {
            ...state.list.page,
            ... action.payload,
          }
        },
        log: []
      }
    case ASSESSMENT_ADD_CHANGE:
      return {
        ...state,
        add: {
          ...state.add,
          data: {
            ...state.add.data,
            new: {
              ...state.add.data.new,
              ...action.payload
            }
          }
        }
      }
    case ASSESSMENT_ADD_SET:
      return {
        ...state,
        add: {
          ...state.add,
          data: action.payload
        }
      }
    case ASSESSMENT_ADD_MODAL_SET:
      return {
        ...state,
        add: {
          ...state.add,
          data: { 
            ...state.add.data,
            new: { code: '', name: '', description: '', if_select: false, url_file: '', original_file_name: '', file_name: '' }
          },
          modal: action.payload
        }
      }
    case ASSESSMENT_ADD:
      return {
        ...state,
        add: {
          ...state.add, 
          loading: true
        }
      }
    case ASSESSMENT_ADD_SUCCESS:
      return {
        ...state,
        add: {
          ...state.add,
          modal: false,
          loading: false,
          message: action.payload.message,
          id: action.payload.id
        }
      }
    case ASSESSMENT_ADD_ERROR:
      return {
        ...state,
        add: {
          ...state.add,
          loading: false,
          message: action.payload.message
        }
      }
    case ASSESSMENT_DETAIL:
      return {
        ...state,
        detail: {
          ...state.detail,
          loading: true,
          data: []
        }
      }
    case ASSESSMENT_DETAIL_SUCCESS:
      return {
        ...state,
        detail: {
          ...state.detail,
          loading: false,
          data: action.payload
        },
        edit: {
          ...state.edit,
          loading: false,
          data: {
            new: action.payload,
            old: action.payload
          }
        }
      }
    case ASSESSMENT_DETAIL_ERROR:
      return {
        ...state,
        detail: {
          ...state.detail,
          loading: false,
          data: []
        }
      }
    case ASSESSMENT_VIEW_MODAL_SET:
      return {
        ...state,
        view: {
          ...state.view,
          modal: action.payload
        }
      }
    case ASSESSMENT_EDIT_MODAL_SET:
      return {
        ...state,
        edit: {
          ...state.edit,
          modal: action.payload
        }
      }
    case ASSESSMENT_EDIT_CHANGE:
      return {
        ...state,
        edit: {
          ...state.edit,
          data: {
            ...state.edit.data,
            new: {
              ...state.edit.data.new,
              ...action.payload
            }
          }
        }
      }
    case ASSESSMENT_UPDATE:
      return {
        ...state,
        edit: {
          ...state.edit,
          data: {
            ...state.edit.data,
            ...action.payload,
          },
          update: {
            ...state.update,
            loading: true,
            response: '',
            message: ''
          }
        }
      }
    case ASSESSMENT_UPDATE_SUCCESS:
      return {
        ...state,
        edit: { 
          ...state.edit,
          modal: false,
          data: {
            ...state.edit.data,
            new: {
              ...state.edit.data.new,
              update_reason: ''
            },
            old: {
              ...state.edit.data.new,
              update_reason: ''
            }
          },
          update: {
            ...state.update,
            loading: false,
            response: 'success',
            message: action.payload
          }
        },
        view: {
          ...state.view,
          modal: false
        }
      }
    case ASSESSMENT_UPDATE_ERROR:
      return {
        ...state,
        edit: {
          ...state.edit,
          update: {
            ...state.update,
            loading: false,
            response: 'error',
            message: action.payload
          }
        }
      }
    case ASSESSMENT_VIEW_TAB_SET:
      return {
        ...state,
        view: {
          ...state.view,
          tab: action.payload
        }
      }
    case ASSESSMENT_UPLOAD_SET:
      return { ...state };
    case ASSESSMENT_UPLOAD_SET_SUCCESS:
      return {
        ...state,
        file: [...state.file, action.payload]
      };
    case ASSESSMENT_UPLOAD_SET_ERROR:
      return { 
        ...state,
        file: [...state.file, action.payload]
      };
    case ASSESSMENT_UPLOAD_RESET:
      return {
        ...state,
        file: []
      };
    default:
      return { ...state };
    }

};